import Controller from '@ember/controller';
import { action } from '@ember/object';
import RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import ENV from 'donor-elf-web/config/environment';

export default class LogoutController extends Controller {
  @service declare router: RouterService;

  @action
  templateDidInsert() {
    document.addEventListener('keydown', this.handleKeyDown);
    setTimeout(() => {
      if (this.router.currentRouteName === 'logout') {
        this.refreshToLoginPage();
      }
    }, 2000);
  }

  @action
  handleKeyDown() {
    this.refreshToLoginPage();
  }

  @action
  refreshToLoginPage() {
    document.removeEventListener('keydown', this.handleKeyDown);
    window.location.replace(ENV.rootURL);
  }
}
